import userApis from 'api/ApiActions/Common/User'
import { StatusCode } from 'lib/StatusCodes'
import type { Error } from 'types/Common'

export const logout = async () => {
  const response = await userApis.logout()
  return response
}

export const handleLoginPageRedirection = async (error: Error) => {
  if (error.response.status === StatusCode.HTTP_404_NOT_FOUND) {
    await userApis.logout()
    window.location.href = `${window.location.origin}/login`
  }
}
